import { Link } from "wouter";
import { useTranslation } from "react-i18next";
import { Instagram } from "lucide-react";
import { SiWhatsapp } from "react-icons/si";
import { BRAND, WHATSAPP_URL } from "@/config/brand";
import logoImg from "@assets/timeclean-logo.jpg";

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[hsl(224,60%,12%)] text-slate-300 py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <Link href="/" className="flex items-center gap-2 mb-6 text-white">
              <img src={logoImg} alt={`${BRAND.nameEn} Logo`} className="h-10 w-10 rounded-lg object-cover" />
              <span className="font-display font-bold text-xl tracking-tight">{BRAND.nameEn}</span>
            </Link>
            <p className="text-sm leading-relaxed opacity-80">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.quickLinks")}</h4>
            <ul className="space-y-2 text-sm">
              <li><Link href="/" className="hover:text-[hsl(19,96%,55%)] transition-colors">{t("nav.home")}</Link></li>
              <li><Link href="/services" className="hover:text-[hsl(19,96%,55%)] transition-colors">{t("nav.services")}</Link></li>
              <li><Link href="/shop" className="hover:text-[hsl(19,96%,55%)] transition-colors">{t("nav.shop")}</Link></li>
              <li><Link href="/booking" className="hover:text-[hsl(19,96%,55%)] transition-colors">{t("nav.booking")}</Link></li>
              <li><Link href="/about" className="hover:text-[hsl(19,96%,55%)] transition-colors">{t("nav.about")}</Link></li>
              <li><Link href="/terms" className="hover:text-[hsl(19,96%,55%)] transition-colors" data-testid="link-footer-terms">{t("footer.terms")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.contact")}</h4>
            <ul className="space-y-2 text-sm">
              <li>{BRAND.displayPhone}</li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4">{t("footer.connect")}</h4>
            <div className="flex gap-4">
              <a href={BRAND.instagramUrl} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-[hsl(224,52%,18%)] flex items-center justify-center hover:bg-[hsl(19,96%,50%)] hover:text-white transition-colors" aria-label="Instagram" data-testid="link-instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-[hsl(224,52%,18%)] flex items-center justify-center hover:bg-[#25D366] hover:text-white transition-colors" data-testid="link-whatsapp">
                <SiWhatsapp className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[hsl(224,45%,24%)] pt-8 text-center text-xs opacity-50">
          © {new Date().getFullYear()} {BRAND.nameEn}. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
}
